import axios from "axios";

const basePath =
	process.env.NODE_ENV === "development"
		? "http://localhost:8000/data/graphql"
		: // ? "https://dev-mev.id.md/data"
		"/data/graphql";

axios.defaults.withCredentials = true;

// if (process.env.NODE_ENV === "development") {
//     axios.defaults.headers.common["auth"] = Cookies.get("simpalsid.auth");
// }

// POST request to GraphQL get all companyes
export function getOrganizations({idno, name, pagination: {start, limit}}) {
	let query = `
      query {
        organizations(pagination: {
          start: ${start},
          limit: ${limit}
        }`;

	if (name) query += `, name: "${name}"`;
	if (idno) query += `, idno: "${idno}"`;

	query += `) {
        count
        data {
          id
          name
          contact
          contactPhone
          contactEmail
          organizationPhone
          organizationEmail
          contract
          idno
          cashRegisters {
            id
            model
            address
            factory
            number
            key
          }
          cashRegistersCount
          watPay
        }
      }
    }`;

	// Perform the request
	const organization = axios({
		url: basePath,
		method: "post",
		data: {
			query,
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err.message;
		});

	return organization;
}

// POST request to GraphQL get companyes by id
export function getOrganizationById(skip = 0, limit = 20) {
	const organization = axios({
		url: basePath,
		method: "post",
		data: {
			query: `
            query {
              organization {
                id,
                name,
                idno,
                contact,
                contactEmail,
                contactPhone,
                organizationEmail,
                organizationPhone,
                contract,
                watPay,
                cashRegisters {
                  id,
                  model,
                  address,
                  factory,
                  number,
                  key,
                  taxes {
                    id
                    title
                    code
                    percent
                    rate
                    enabled
                  }
                },
                cashRegistersCount,
              }
            }
          `,
		},
	})
		.then((res) => {
			// console.log("get all receipts success");
			return res.data;
		})
		.catch((err) => {
			// console.log("get all receipts error");
			return err.message;
		});
	return organization;
}

// POST request to GraphQL create new organization
//TODO: fix wat pay
export async function createNewOrganization(organization) {
	try {
		const res = await axios({
			url: basePath,
			method: "post",
			data: {
				query: `
          mutation($input: OrganizationCreateInput!){
            createOrganization(input: $input) {
                id
            }
          }
        `,
				variables: {
					input: {
						name: organization.name,
						contact: organization.contact,
						contactPhone: organization.contactPhone,
						contactEmail: organization.contactEmail,
						organizationPhone: organization.organizationPhone,
						organizationEmail: organization.organizationEmail,
						contract: organization.contract,
						idno: organization.idno,
						watPay: !!organization.watPay,
					},
				},
			},
		});
		return res;
	} catch (err) {
		return err.message;
	}
}

// POST request to GraphQL update organization
//TODO: fix wat pay
export function updateOrganization(organization) {
	return axios({
		url: basePath,
		method: "post",
		data: {
			query: `
          mutation($input: OrganizationUpdateInput!){
            updateOrganization(input: $input) { id }
          }
        `,
			variables: {
				input: {
					Id: organization.id,
					name: organization.name,
					contact: organization.contact,
					contactPhone: organization.contactPhone,
					contactEmail: organization.contactEmail,
					organizationPhone: organization.organizationPhone,
					organizationEmail: organization.organizationEmail,
					contract: organization.contract,
					idno: organization.idno,
					watPay: !!organization.watPay,
				},
			},
		},
		// config: config,
	})
		.then((res) => {
			// console.log(res);
			return res;
		})
		.catch((err) => {
			return err.message;
		});
}

// POST request to GraphQL create new CashRegister
export function createNewCashRegister(cashRegister, organizationId) {
	return axios({
		url: basePath,
		method: "post",
		data: {
			query: `
       mutation{
        createCashRegister(
          input: {
            organizationId: ${organizationId}
            address: "${cashRegister.address}"
            number: "${cashRegister.number}"
            key: "${cashRegister.key}"
            subdivision: "${cashRegister.subdivision}"
            point: "${cashRegister.point}"
            deleted: ${cashRegister.deleted}
            activityType: ${cashRegister.activityType || 'UNDEFINED'}
          }
        ) {
            id
        }
      }`,
		},
		// config: config,
	})
		.then((res) => {
			// console.log(res);
			return res;
		})
		.catch((err) => {
			return err.message;
		});
}

// POST request to GraphQL update CashRegister
export function cashRegisterUpdate(cashRegister, organizationId) {
	return axios({
		url: basePath,
		method: "post",
		data: {
			query: `
       mutation{
        updateCashRegister(
          input: {
            organizationId: ${organizationId}
            Id: ${cashRegister.id}
            address: "${cashRegister.address}"
            number: "${cashRegister.number}"
            key: "${cashRegister.key}"
            subdivision: "${cashRegister.subdivision}"
            point: "${cashRegister.point}"
            deleted: ${cashRegister.deleted}
            activityType: ${cashRegister.activityType || 'UNDEFINED'}
          }
        ) {
          id
        }
      }`,
		},
		// config: config,
	})
		.then((res) => {
			// console.log(res);
			return res;
		})
		.catch((err) => {
			return err.message;
		});
}

// POST request to GraphQL cash Register Api Key Refresh
export function cashRegisterApiKeyRefresh(cashId) {
	const organization = axios({
		url: basePath,
		method: "post",
		data: {
			query: `
       mutation{
        cashRegisterApiKeyRefresh(
          id: ${cashId},
        ){errors {message}}
      }`,
		},
	})
		.then((res) => {
			// console.log("get all receipts success");
			return res.data;
		})
		.catch((err) => {
			// console.log("get all receipts error");
			return err.message;
		});
	return organization;
}

// POST request to GraphQL get cash register by id
export function getCashById(cashId) {
	const organization = axios({
		url: basePath,
		method: "post",
		data: {
			query: `
         query {
            organization(cashRegisterId: ${cashId}) {
              id,
              name,
              idno,
              contact,
              contactEmail,
              contactPhone,
              organizationEmail,
              organizationPhone,
              cashRegisters {
                id,
                model,
                address,
                factory,
                number,
                key,
                point,
                activityType,
                subdivision,
                deleted,
                taxes {
                    id
                    title
                    code
                    percent
                    rate
                    enabled
                }
              }
            }
          }`,
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err.message;
		});
	return organization;
}


export function getCurrentUser() {
	const user = axios({
		url: basePath,
		method: "post",
		data: {
			query: `
         query {
            currentUser{
                login
                id
                role
                status
                email
                organizationId
                cashRegisterIds
            }
          }`,
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err.message;
		});
	return user;
}

export function getUsersList() {
	const users = axios({
		url: basePath,
		method: "post",
		data: {
			query: `
         query {
            users{
                login
                id
                role
                status
                email
                organizationId
                cashRegisterIds
            }
          }`,
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err.message;
		});
	return users;
}


export function getUser({id}) {
	const users = axios({
		url: basePath,
		method: "post",
		data: {
			query: `
         query {
            user(Id: ${id}){
                login
                id
                role
                status
                email
                organization_id: organizationId
                cash_register_ids: cashRegisterIds
            }
          }`,
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err.message;
		});
	return users;
}


//
// // POST request to GraphQL get all users
// export function getUsers() {
//     const organization = axios({
//         url: basePath,
//         method: "post",
//         data: {
//             query: `
//          query{
//           getUsers{
//             id, simpalsLogin, simpalsId, profiles{name,  organizationId, roles{id, organizationId,role}}
//             }
//         }`,
//         },
//     })
//         .then((res) => {
//             // console.log("get all receipts success");
//             return res.data;
//         })
//         .catch((err) => {
//             // console.log("get all receipts error");
//             return err.message;
//         });
//     return organization;
// }
//
// // POST request to GraphQL get all users
// export function getUserById(userId) {
//     const organization = axios({
//         url: basePath,
//         method: "post",
//         data: {
//             query: `
//        query{
//         getUser(id: ${userId}){
//           id, simpalsLogin, simpalsId, profiles{name,  organizationId, roles{id, organizationId,role}}
//           }
//       }`,
//         },
//     })
//         .then((res) => {
//             // console.log("get all receipts success");
//             return res.data;
//         })
//         .catch((err) => {
//             // console.log("get all receipts error");
//             return err.message;
//         });
//     return organization;
// }
//
// // POST request to GraphQL create user
// export function createUser(user) {
//     const organization = axios({
//         url: basePath,
//         method: "post",
//         data: {
//             query: `
//        mutation{
//         userCreate(
//           input: {
//             name: "${user.name}",
//             simpalsId: "${user.simpalsId}"
//             simpalsLogin: "${user.simpalsLogin}"
//             organizationId: ${user.organizationId}
//           },
//         ){errors {message}}
//       }`,
//         },
//     })
//         .then((res) => {
//             // console.log("get all receipts success");
//             return res.data;
//         })
//         .catch((err) => {
//             // console.log("get all receipts error");
//             return err.message;
//         });
//     return organization;
// }


// export function getSimpalsIdBySimpalsLogin(simpalsLogin){
//   console.log(simpalsLogin)
//   const request = axios({
//     url: `http://accounts.service.simpals:18333/v1.0/users?login=${simpalsLogin}`,
//     method: 'GET',
//     headers: {
//       'Cache-Control': 'no-cache',
//       'Host': 'accounts.service.simpals:18333',
//       'Connection': 'keep-alive',
//       'Content-Type' : 'application/json',
//     },
//   })
//   return request;
// }

// // POST request to GraphQL create new z report
// export function createNewReport(cashId, type) {
//     return axios({
//         url: basePath,
//         method: 'post',
//         data: {
//          query: `
//          mutation{
//             generateReport(cashRegisterId:${cashId} compartiment:ACPS, type:${type}){
//               errors {
//                 message
//               }
//             }
//           }`
//         },
//         // config: config,
//     })
//     .then(res => {
//         // console.log(res);
//         return res;
//     })
//     .catch(err => {
//         return err.message;
//     });
// }

// // POST request to GraphQL get current organization
// export function getCurrentOrganization() {

//     // let tempCookie = Cookies.get('simpalsid.auth');
//     // console.log(tempCookie);
//     // Cookies.remove('simpalsid.auth');
//     const organization = axios({
//         url: basePath,
//         method: 'post',
//         data: {
//          query: `
//          query {
//             getCurrentInfo{organization{
//               name, idno,
//               cashRegisters{
//                 id, model,address,factory,number,key
//               }
//             }}
//           }`
//         },
//     })
//     .then(res => {
//         // console.log("get organization success");
//         return res.data
//     })
//     .catch(err => {
//         // console.log("get organization error");
//         return err.message
//     });
//     return organization;
// }

// // POST request to GraphQL get current user
// export function getCurrentUser() {
//   const organization = axios({
//       url: basePath,
//       method: 'post',
//       data: {
//        query: `
//        query {
//         getCurrentInfo{account{
//           userId,login
//         }}
//       }`
//       },
//   })
//   .then(res => {
//       // console.log("get user success");
//       return res.data
//   })
//   .catch(err => {
//       // console.log("get user error");
//       return err.message
//   });
//   return organization;
// }

// // POST request to GraphQL get all reports
// export function getAllMyReports() {
//     const organization = axios({
//         url: basePath,
//         method: 'post',
//         data: {
//          query: `
//          query{
//           getReports(sort: {column: "_id", direction: DESC}){
//             count,
//             data{
//               id,
//               soapData{
//                 id, type, report, datetime,
//                 reports{
//                   daily{total}
//                   year{total}
//                 }
//               },
//               status,
//             },
//           }
//         }`
//         },
//     })
//     .then(res => {
//         // console.log("get getReports success");
//         return res.data
//     })
//     .catch(err => {
//         // console.log("get getReports error");
//         return err.message
//     });
//     return organization;
// }

// // POST request to GraphQL get all receipts
// export function getAllMyReceipts() {
//   const organization = axios({
//       url: basePath,
//       method: 'post',
//       data: {
//        query: `
//        query{
//         getFiscalReceipts(sort: {column: "_id", direction: DESC}){
//           count,
//           data{
//             id,
//             soapData{
//               id,receipt,report, datetime, activity{total, payments{field{type}}}
//             },
//             status,
//           }
//         }
//       }`
//       },
//   })
//   .then(res => {
//       // console.log("get all receipts success");
//       return res.data
//   })
//   .catch(err => {
//       // console.log("get all receipts error");
//       return err.message
//   });
//   return organization;
// }

// // POST request to GraphQL  Get Receipt by id
// export function getReceiptById(id) {
//   const organization = axios({
//       url: basePath,
//       method: 'post',
//       data: {
//        query: `
//        query {
//         getFiscalReceipt(id: ${id}){
//         id,status, compartiment,
//         soapData{
//           id, report, receipt, datetime, card{
//             name, address, idnx, factory, number
//           },
//           activity{
//             total, taxes{field{code, percent,rate}},
//             payments{field{type}},
//             activities{field{
//               name, amount, price,
//               tax{code, percent,rate}, cost}}
//           }
//         }
//       }
//       }`
//       },
//   })
//   .then(res => {
//       // console.log("get receipt success");
//       return res.data
//   })
//   .catch(err => {
//       // console.log("get receipt error");
//       return err.message
//   });
//   return organization;
// }

// // POST request to GraphQL  Get report by id
// export function getReportById(id) {
//   const organization = axios({
//       url: basePath,
//       method: 'post',
//       data: {
//        query: `
//        query {
//         getReport(id: ${id}){
//         id,status, compartiment,
//         soapData{
//           id, report, type, datetime, card{
//             name, address, idnx, factory, number
//           },
//           reports{
//             daily{
//               taxes{
//                 field{
//                   code, percent, rate, total
//                 }
//               },
//               untaxed, total, tax,
//               receipts{
//                 field{
//                   type, count
//                 }
//               },
//               payments{
//                 field{type, sum}
//               },
//               totals{introduced,issued,balance}
//             },
//             year{total, tax}
//           }
//         }
//       }
//       }`
//       },
//   })
//   .then(res => {
//       // console.log("get receipt success");
//       return res.data
//   })
//   .catch(err => {
//       // console.log("get receipt error");
//       return err.message
//   });
//   return organization;
// }

// // POST request to GraphQL get all service receipts
// export function getAllMyServiceReceipts() {
//   const organization = axios({
//       url: basePath,
//       method: 'post',
//       data: {
//        query: `
//        query{
//         getServiceReceipts(sort: {column: "_id", direction: DESC}){
//           count,
//           data{
//             id,
//             soapData{
//               id,report, datetime,
//               activity{total, type, name}
//             },
//             status,
//           }
//         }
//       }`
//       },
//   })
//   .then(res => {
//       // console.log("get all receipts success");
//       return res.data
//   })
//   .catch(err => {
//       // console.log("get all receipts error");
//       return err.message
//   });
//   return organization;
// }

// // POST request to GraphQL  Get Service Receipt by id
// export function getServiceReceiptById(id) {
//   const organization = axios({
//       url: basePath,
//       method: 'post',
//       data: {
//        query: `
//        query {
//         getServiceReceipt(id: ${id}){
//         id,status, compartiment,
//         soapData{
//           id, report, datetime, card{
//             name, address, idnx, factory, number
//           },
//           activity{
//             total, name, type
//           }
//         }
//       }
//       }`
//       },
//   })
//   .then(res => {
//       // console.log("get receipt success");
//       return res.data
//   })
//   .catch(err => {
//       // console.log("get receipt error");
//       return err.message
//   });
//   return organization;
// }
